import { ChainId } from '@pancakeswap/sdk'

export const SUPPORT_ONLY_BSC = [ChainId.SOMNIA]
export const SUPPORT_FARMS = [ChainId.BSC, ChainId.BSC_TESTNET, ChainId.GOERLI, ChainId.SOMNIA]

export const SUPPORT_ZAP = [ChainId.BSC, ChainId.BSC_TESTNET]
